const PROD_URL = 'https://collections-admin.uk.getbits.app';
const DEV_URL = 'https://collections-admin.dev.getbits.app';

const PROD_ADMIN_HOSTNAME = 'admin.getbitscard.com';

/**
 * Only the prod admin panel domain links to the prod collections dashboard - the dev domain,
 * CloudFront URLs and localhost all link to dev.
 */
export const collectionsAdminUrl = (hostname: string): string =>
  hostname === PROD_ADMIN_HOSTNAME ? PROD_URL : DEV_URL;
